import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-win.svg";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from "../../Common/LanguageSelector";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const ContactWin = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const formDatapaymyself = location.state;
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  console.log("Received form data:", formDatapaymyself);
  const [logo, setLogo] = useState(null);

  useEffect(() => {

    const loadLogo = async () => {
      if (isHighmarkPortal) {
        const logoModule = await import("./../../assets/images/highmark/ffb-logo.jpg");
        setLogo(logoModule.default);
      } else {
        const logoModule = await import("./../../assets/images/win/logo-win.svg");
        setLogo(logoModule.default);
      }
    };

    loadLogo();
  }, [ssoData]);
  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
  const handleBackClick = () => {
    // Pass updatedFormData and otherData back to /benefit-options
    const updatedFormData = formDatapaymyself?.updatedFormData || formDatapaymyself?.updatedProviderData || {};
    const otherData = formDatapaymyself?.otherData || {};
    navigate("/benefit-options", { state: { combinedFormData: updatedFormData, otherData } });
  };

  return (
    <>
    {/* <div> <LanguageSelector /></div> */}
      {/* Header */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
          {isHighmarkPortal ? 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          : 
            <img src={logo} alt="Logo" className="logo brand-logo" />
          }            
          </a>
        </nav>
      </header>

      <div className="registration-block-main">
        {/* left carousel start */}
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>
        {/* left carousel end */}

        {/* registration right form area start */}
        <div className="registration-form-main">
          <div className="registration-form">
            
            <h3 className="page-heading-secondary-black">{t('callourteam')}</h3>
            {/* <h3 className="page-heading-bold">Username</h3> */}
            <p>{t('contactwinmsg')}</p>
            <div className="registration-process-form-wrapper mt-5">
              <form>
                
               
                <div className="mb-3">
                  {/* <button className="win-btn-secondary-w-100 mt-4" type="submit">
                  {t('call')}
                  </button> */}
                  <h3 className="page-heading-bold ">(877)767.0525</h3>
                </div>
                <div className="mb-3 mt-5">
                {isHighmarkPortal ? (
                  <div className="pagination-wrapper mt-5">
                  <button className="previous-btn" onClick={handleBackClick} type="button"></button>
                  </div>
                ) : (
                <button className="win-btn-secondary me-3"  onClick={handleBackClick}>{t('back')}</button>
                )}
                </div>
              </form>
            </div>

          </div>
        </div>
        {/* registration right form area end */}
        {/* <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} /> */}
      </div>        
    </>
  );
};
export default ContactWin;
